import { useAuthContext } from '../context/AuthContext';
import { ROLES, normalizeRole, hasRole } from './roles';

export default function useRole() {
  const { auth } = useAuthContext();
  const role = normalizeRole(auth?.user?.role);

  return {
    // The normalised role string ('admin', 'user', or '')
    role,

    // Shortcut for the most common check
    isAdmin: role === ROLES.ADMIN,

    // Allow-list check: can([ROLES.ADMIN]) → true/false
    can: allowed => hasRole(role, allowed),

    // auth_method-based permission — SSO users cannot change password
    // (their password is managed by the identity provider, not this app)
    canChangePassword: auth?.auth_method !== 'sso',
  };
}
